export const errorTypes = {
  userNotRegistered: 'USER_DOES_NOT_EXIST',
  tokenExpired: 'INVALID_TOKEN',
  networkError: 'ERR_NETWORK',
  notFound: 'NOT_FOUND',
};

export const errorMessages = {
  tokenExpired: 'Session expired, you will be redirected to the sign in page.',
  posSessionExpiredToaster:
    'This session has expired. This could be due to a new login on the same account. Generating a new session in the background. Please try again to continue',
  tokenExpiredToaster:
    'This session has expired. This could be due to a new login on the same account. Please login again or reload the page to continue',
  networkError: 'Network error',
  registrationError: 'Unable to identify the seller. Please try again.',
  fileNotSupported: 'This file type is not supported.',
  multipleFilesNotSupported: 'Multiple files are not allowed. Please try again with a single file.',
  mobileNotSupported:
    'Sorry, the feature you are trying to access is not supported on the mobile view of our web app. Please switch to a desktop or tablet device for the best user experience. We apologize for any inconvenience.',
  preLoginError:
    "We're sorry, but we encountered a problem while trying to access the sign-in page. This could be due to a temporary issue with our servers or a problem with your internet connection. Please try refreshing the page or check your internet connection. If the issue persists, please contact our support team for assistance.",
  errorBoundary:
    "We're sorry, but we encountered a problem while trying to access this page. This could be due to a temporary issue with our servers or a problem with your internet connection. Please try refreshing the page or check your internet connection. If the issue persists, please contact our support team for assistance.",
  errorScreen: {
    header: "Oops! Something went wrong.",
    description: "We're sorry, but it seems like we're experiencing technical difficulties",
    message: "You will be",
    messageHighlight: "redirected to homepage"
  }
};
